<template>
  <div class="news-container">
    <div class="header">
      <div class="title">
        <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x6.png" alt="" />
        <span>试卷<span class="highlight">题库</span></span>
        <div class="ll"></div>
        <span class="lll">PREMIUM COURSES</span>
      </div>
      <div @click="goNext('/partnerPage/quesTionList')" class="more">
        查看更多
        <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x7.png" alt="" />
      </div>
    </div>
    <div class="course-list">
      <div @click="goPage(course)" v-for="(course, index) in courses" :key="index" class="course-card"
        :class="course.bgClass">
        <img style="width: 265px;
height: 148px;
border-radius: 10px 10px 0px 0px;" :src="course.image" alt="">
        <div class="titles twoEllipsis">{{ course.name }}</div>

        <div class="price-popularity">
          <span class="price"> <span>¥</span>{{ course.packagePrice }}</span>
          <span class="popularity">
            {{ course.paperNum !== undefined ? course.paperNum : (course.paperNameList ? course.paperNameList.length : 0) }}套试卷
          </span>
        </div>
      </div>
      <el-empty style="margin: 0 auto;" v-if="courses.length == 0" description="暂无数据"></el-empty>
    </div>

  </div>
</template>

<script>
import { HomeClient } from '@/api/home'
import { getInfo } from '@/api/cookies'
const homeClient = new HomeClient()

export default {
  name: "NewsDynamic",
  data() {
    return {
      courses: [
      ],
      userInfo: null,
      imgs: {}
    };
  },
 async created() {
    this.getList();
    this.userInfo = await getInfo()
  },
  methods: {
    async getList() {
      const res = await homeClient.getPaperPackageList({ pageSize: 5, pageNum: 1 })
      // 仅使用试卷包列表，适配现有卡片的价格、数量和封面字段。
      this.courses = (res.data.rows || []).map((item) => ({
        ...item,
        packagePrice: item.price !== undefined ? item.price : item.packagePrice,
        paperNum: item.paperNum != null
          ? item.paperNum
          : (item.paperNameList ? item.paperNameList.length : 0),
        image: item.image || 'https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/study/pagerBank.png',
      }))


    },
    goPage(row, column, cell, event) {
      if (this.userInfo) {
        this.$router.push(`/all/examPackPartner?packId=${row.id}`)
      } else {
        this.$notify({
          title: '错误',
          message: '未登录，请去登录',
          type: 'error'
        })
        // Vue.prototype.goLoginView(true)
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.news-container {
  max-width: 1400px;
  margin: 0 auto;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin-top: 30px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.title {
  display: flex;
  align-items: center;

  font-family: DingTalk JinBuTi, DingTalk JinBuTi;
  font-weight: 400;
  font-size: 34px;

  img {
    width: 41px;
    margin-right: 9px;
  }

  .ll {
    margin: 0 17px;
    width: 0px;
    height: 28px;
    border-right: 1px solid #bbbbbb;
  }

  .lll {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #999999;
  }
}

.title .icon-news {
  width: 20px;
  height: 20px;
  background-color: #007bff;
  border-radius: 50%;
  margin-right: 8px;
}

.title .highlight {
  color: #007bff;
  margin-left: 4px;
}

.more {
  cursor: pointer;
  display: flex;
  align-items: center;

  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #666666;

  img {
    width: 31px;
    margin-left: 4px;
  }
}

.course-list {
  display: flex;
  flex-wrap: wrap;
}

.course-card {
  width: 265px;
  height: 270px;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  margin-right: 18px;
  margin-bottom: 20px;

  &:nth-child(5n) {
    margin-right: 0;
  }

  .titles {
    width: 235px;
    height: 52px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 18px;
    color: #333333;
    line-height: 26px;
    margin: 14px;
  }

}

.price-popularity {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 14px;

  .price {

    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 20px;
    color: #FB2D25;

    span {
      font-size: 14px;
      margin-right: 4px;

    }
  }

  .popularity {
    display: flex;
    align-items: center;

    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;

  }
}
</style>
